module.exports = __webpack_public_path__ + "static/media/calendly-logo.f32e94f7.png";